module.exports = __webpack_public_path__ + "img/input-minus.afc070fb.svg";